import "./processEnvShim";
import React from "react";
import ReactDOM from "react-dom";

import NextApp from './NextApp';
// import registerServiceWorker from './registerServiceWorker';
// Add this import:
import {AppContainer} from 'react-hot-loader';
import * as serviceWorker from './registerServiceWorker';


// Wrap the rendering in a function:
const render = Component => {
  ReactDOM.render(
    // Wrap App inside AppContainer
    <AppContainer>
      <Component/>
    </AppContainer>,
    document.getElementById('root')
  );
};

// Unregister service worker — no offline use needed.
// Version updates are handled by CacheBuster.js
serviceWorker.unregister();

// Do this once

// Render once
render(NextApp);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./NextApp', () => {
    render(NextApp);
  });
}
